import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { getTimezones } from "../../../services/user";
import { toast } from "react-toastify";

export const useTimezones = () => {
  const query = useQuery({
    queryKey: ["timezones"],
    queryFn: getTimezones,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) =>
      (data || []).map((tz) => ({
        label: tz.hours,
        value: tz.name,
      })),
  });

  useEffect(() => {
    if (query.error) {
      toast.error("Can't load timezones data. Try again later");
    }
  }, [query.error]);

  return {
    timezones: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
};
